import { Box } from '@mui/material';

/** Main content canvas — rounded surface matching the new shell design. */
export const WorkspaceShell = ({ children }) => {
    return (
        <Box
            sx={{
                flex: 1,
                minHeight: 0,
                minWidth: 0,
                pb: '16px',
                pr: '16px',
                bgcolor: '#FFFFFF',
                overflow: 'hidden',
            }}
        >
            <Box
                className="overflowY noScrollcss"
                sx={{
                    height: '100%',
                    minHeight: 0,
                    borderRadius: '16px',
                    bgcolor: '#F7F8FA',
                    overflow: 'hidden',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
